/* web/style.css "nearby list": mini cards in the side panel; at phone width a bar at the bottom that pulls up. */
.nearby { flex: 1; overflow-y: auto; padding: 0 16px 20px; animation: global(sheet-in) .25s var(--ease); }
.nearby[data-under-sheet] { display: none; }
/* As much space above the title row as below it (12 desktop, 8 phone: below the grabber). */
.head { position: sticky; top: 0; z-index: 1; background: var(--surface); padding: 12px 4px 12px; }
.head h3 { margin: 0; font-size: 18px; font-weight: 700; flex: 1; min-width: 0; }
.titleRow { display: flex; align-items: center; gap: 10px; }
.grabber { display: none; }
/* Cards or list (nowish.json nearbyViews): two icon buttons in one pill, the chosen one raised. */
.toggle { flex: none; display: inline-flex; gap: 2px; padding: 2px; border-radius: 999px; background: var(--fill); }
.opt { display: inline-flex; align-items: center; justify-content: center; width: 38px; height: 30px; padding: 0; border: 0; border-radius: 999px; background: transparent; color: var(--muted); transition: background .2s, color .2s, box-shadow .2s; }
.opt :global(.icon) { width: 18px; height: 18px; }
.opt:hover { color: var(--text); }
.opt[aria-checked="true"] { background: var(--surface); color: var(--text); box-shadow: 0 1px 3px rgba(0, 0, 0, .12); }
.mini { position: relative; isolation: isolate; background: var(--surface); margin-bottom: 12px; border-radius: var(--radius); box-shadow: var(--shadow); overflow: hidden;
  transition: box-shadow .2s, opacity var(--hover-ms, .15s), border-radius var(--hover-ms, .15s); }
/* The hover outline (--hover-outline on the hovered card): over everything in the card, inside its edge. */
.mini::after { content: ""; position: absolute; inset: 0; z-index: 1; border: 2px solid var(--hover-outline, transparent); border-radius: inherit; pointer-events: none; transition: border-color var(--hover-ms, .15s); }
.atTop .items { position: relative; z-index: 2; }
.open { display: block; width: 100%; text-align: left; border: 0; background: transparent; padding: 0; color: inherit; }
.star { position: absolute; right: 8px; bottom: 12px; }
.mini:hover { box-shadow: 0 0 0 1px rgba(0, 0, 0, .02), 0 6px 20px rgba(0, 0, 0, .14); }
.img { border-radius: 0; }
.img img { max-height: 200px; }
.row { display: flex; align-items: center; gap: 12px; padding: 12px 48px 12px 14px; }
.text { min-width: 0; display: flex; flex-direction: column; gap: 2px; }
.t { font-weight: 600; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; }
.m { font-size: 14px; color: var(--muted); }
.m b { color: var(--text); font-weight: 500; }
.m b:global(.tone-now) { color: var(--now-text); }
.m b:global(.tone-soon) { color: var(--soon-text); }
/* Cards off screen aren't laid out or painted, so a long list scrolls as smoothly as a short one. */
.asCards .mini { content-visibility: auto; contain-intrinsic-size: auto 280px; }
/* The list: compact rows split by hairlines, no flyer. */
.asList .img { display: none; }
.asList .mini { margin: 0; border-radius: 0; box-shadow: none; border-top: 1px solid var(--line-soft); overflow: visible; }
.asList .mini::after { top: -1px; }
.asList .mini:hover { box-shadow: none; background: var(--fill); }
.more { height: 1px; }

@media (max-width: 760px) {
  .nearby {
    pointer-events: auto; position: fixed; left: 0; right: 0; bottom: 0; z-index: 2; padding: 0 0 12px;
    max-height: var(--bar-h, 160px); overflow: hidden; background: var(--surface); border-radius: 28px 28px 0 0;
    box-shadow: 0 -2px 6px rgba(0, 0, 0, .04), 0 -8px 28px rgba(0, 0, 0, .14);
    animation: none; transition: max-height .25s var(--ease), transform .25s var(--ease);
  }
  .expanded { max-height: 72vh; overflow-y: auto; }
  .nearby[data-under-sheet] { display: block; transform: translateY(105%); }
  :global(body.types-open) .nearby { transform: translateY(calc(100% + 24px)); }
  .head { padding: 12px 20px 8px; border-radius: 28px 28px 0 0; touch-action: none; cursor: pointer; }
  .grabber { display: block; width: 100%; height: 18px; margin: -4px 0 1px; border: 0; background: transparent; position: relative; touch-action: none; }
  .grabber::after { content: ""; position: absolute; left: 50%; top: 6px; width: 36px; height: 5px; margin-left: -18px; border-radius: 3px; background: var(--line); }
  .asCards .mini { margin: 0 16px 12px; }
  .asList .row { padding: 9px 48px 9px 20px; }
  .t { -webkit-line-clamp: 1; font-size: 15px; }
  .m { font-size: 13px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
}
